// CRA host configuration only. New AI screens continue to use React/Vite.
function required(name,value){if(!value||!value.trim())throw new Error('Missing public configuration: '+name);return value.trim()}
export const API_URL=required('REACT_APP_API_URL',process.env.REACT_APP_API_URL).replace(/\/$/,'');
export const MAPS_KEY=process.env.REACT_APP_MAPS_KEY||'';
export const SENTRY_DSN=process.env.REACT_APP_SENTRY_DSN||'';
export const ENVIRONMENT=required('REACT_APP_ENV',process.env.REACT_APP_ENV);
export const SENTRY_ENABLED=process.env.REACT_APP_SENTRY_ENABLED==='true';
